export const gateway = '/api/'
const html_docx = gateway + 'py/html_docx'
const cnki = gateway + 'py/cnki'
const docx_md = gateway + 'py/docx_md'
const doc_docx = gateway + 'py/doc_docx'
const pdf_report = gateway + 'py/pdf_report'
const typeset_docx = gateway + 'py/typeset_docx' // 格式排版
const showqrcode = gateway + 'showqrcode'
const userinfo = gateway + 'userinfo'
const loop_login = gateway + 'loop_login'
const user_account = gateway + 'user_account'
const work_list = gateway + 'work_list'
const work_delete = gateway + 'work_delete'
const work_data = gateway + 'work_data'
const upload_work_data = gateway + 'upload_work_data'
const uploadImage = gateway + 'uploadImage'
const uploadFile = gateway + 'v2/ai/uploadFile'
const prompts_join = gateway + 'prompts_join'
const ai_content = gateway + 'ai_content'
const pay = gateway + 'pay'
const pay_result = gateway + 'pay_result'
const expend = gateway + 'expend'
const ppt = gateway + 'ppt'
const ppt_raw = gateway + 'py/ppt_raw'
const ppt_stream = gateway + 'py/ppt_stream'
const parseFile = gateway + 'presentation/outline/import'
const theme = gateway + 'presentation/theme' // get获取主题 post修改主题
const outline = gateway + 'presentation/outline' // 生成大纲
const diagram = gateway + 'presentation/diagram' // get 获取图示资源   post 修改图示资源
const historyId = gateway + 'presentation/history'
const history = gateway + 'presentation/history'
const presentation = gateway + 'presentation' // ⽣成 PPT
const reduce_aigc_ibl = gateway + 'reduce_aigc_ibl'
const agent_apply = gateway + 'agent_apply'
const simplify_file = gateway + '/py/simplify_file'

export const apiGroup: any = {
  html_docx,
  docx_md,
  cnki,
  showqrcode,
  loop_login,
  user_account,
  work_list,
  work_delete,
  work_data,
  upload_work_data,
  uploadImage,
  uploadFile,
  prompts_join,
  ai_content,
  pay,
  pay_result,
  expend,
  userinfo,
  ppt,
  parseFile,
  ppt_stream,
  doc_docx,
  pdf_report,
  theme,
  outline,
  diagram,
  historyId,
  ppt_raw,
  history,
  presentation,
  reduce_aigc_ibl,
  typeset_docx,
  agent_apply,
  simplify_file
}
